import { Box } from '@mui/material'
import { styled } from '@mui/material/styles'

export const TabsWrapper = styled(Box)(({ theme, displayDesktop, displayMobile }) => ({
  display: displayDesktop !== false ? 'block' : 'none',
  [theme.breakpoints.down('sm')]: {
    display: displayMobile !== false ? 'block' : 'none',
  },
}))

export const TabsHeaderWrapper = styled(Box)(({ theme, showMeganavMobile, showToolbar, stickyOffset }) => ({
  position: 'sticky',
  textAlign: 'center',
  top: `${stickyOffset}px`,
  transition: '0.1s ease-in-out',
  zIndex: 10,
  paddingTop: '8px',
  '&.sticky-on-top': {
    backgroundColor: theme.palette.common.white,
    boxShadow: '-2px 2px 3px 0px rgba(0, 0, 0, 0.20)',
    margin: '0px -15px',
    paddingLeft: '12px',
    paddingRight: '12px',
    [theme.breakpoints.up('sm')]: {
      margin: '0px -500px',
      paddingLeft: 0,
      paddingRight: 0,
    },
  },

  [theme.breakpoints.down('md')]: {
    display: 'block',
    top: `${124 - (showMeganavMobile ? 0 : 48) - (showToolbar ? 0 : 16)}px`,
    backgroundColor: theme.palette.common.white,
    margin: '0px -15px',
    paddingLeft: '12px',
    paddingRight: '12px',
  },
}))

export const TabsHeader = styled(Box)(({ theme, showMeganavMobile, hideInfoBanner }) => ({
  margin: '0',
  zIndex: 100,
  display: 'inline-block',
  maxWidth: '100%',
  overflowX: 'auto',
  overflowY: 'hidden',
  scrollSnapType: 'x proximity',
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  backgroundColor: '#F5F5F5',
  boxShadow: '0px 1px 4px 0px rgba(0, 0, 0, 0.20) inset',
  borderRadius: '50px',
}))

export const TabButtons = styled(Box)(({ theme, multipleTabs, value, tabsLength }) => ({
  [theme.breakpoints.down('sm')]: {
    marginRight: multipleTabs ? '-15px' : null,
  },
  margin: '0 auto',
  display: 'flex',
  position: 'relative',
  gap: multipleTabs ? '8px' : '16px',
  width: 'fit-content',
  padding: '6px 8px',
  '*': {
    zIndex: 2,
  },
  '& > button': {
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: 'unset',
    minWidth: '0',
    boxSizing: 'border-box',
    whiteSpace: 'nowrap',
    alignItems: 'center',
    justifyContent: 'center',
    height: '44px',
    padding: '8px 24px',
    fontSize: '1.25rem',
    fontWeight: 600,
    borderRadius: '50px',
    cursor: 'pointer',
    transition: 'color 0.15s ease-in',
    color: theme.palette.primary.dark,
    '&.checked': {
      color: theme.palette.common.white,
      zIndex: 11,
    },
    [theme.breakpoints.down('sm')]: {
      height: '32px',
      fontSize: '16px',
      padding: '6px 16px',
    },
  },
  '.indicator': {
    position: 'absolute',
    display: 'flex',
    height: '44px',
    backgroundColor: '#0053A0',
    zIndex: 10,
    borderRadius: '50px',
    transition: '0.15s ease-out',
    [theme.breakpoints.down('sm')]: {
      height: '32px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.125rem',
    padding: '4px 6px',
  },
}))

export const TabPanelStyles = styled('div')(({ theme }) => ({
  margin: '20px 0',
  '& .collection-buttons a': {
    padding: '5px 10px',
  },
  [theme.breakpoints.down('sm')]: {
    margin: '0',
  },
}))
